import axios from 'axios';

export const GET_API = async (
  url,
  token,
  dataHeader = {},
  dataQuery = {},
  props = {},
) => {
  const res = await axios.get(url, {
    headers: {
      Authorization: `${token}`,
      'Content-Type': 'application/json',
      ...dataHeader,
    },
    params: dataQuery,
    ...props,
  });
  const { data, status } = res;
  return { status, data };
};

export const POST_API = async (
  url,
  token,
  dataHeader = {},
  dataBody = {},
  props = {},
) => {
  const res = await axios.post(
    url,
    {
      ...dataBody,
    },
    {
      headers: {
        Authorization: `${token}`,
        'Content-Type': 'application/json',
        ...dataHeader,
      },
      ...props,
    },
  );
  const { data, status } = res;
  return { status, data };
};

export const PUT_API = async (url, token, dataHeader = {}, dataBody = {}) => {
  const res = await axios.put(
    url,
    {
      ...dataBody,
    },
    {
      headers: {
        Authorization: `${token}`,
        'Content-Type': 'application/json',
        ...dataHeader,
      },
    },
  );
  const { data, status } = res;
  return { status, data };
};

export const DELETE_API = async (
  url,
  token,
  dataHeader = {},
  dataBody = {},
) => {
  const res = await axios.delete(
    url,
    {
      ...dataBody,
    },
    {
      headers: {
        Authorization: `${token}`,
        'Content-Type': 'application/json',
        ...dataHeader,
      },
    },
  );
  const { data, status } = res;
  return { status, data };
};
